module.exports = __webpack_public_path__ + "static/austinpowder-logo-4c236ed793861b4b23fe6b69336fc5f5.jpeg";